module.exports = __webpack_public_path__ + "static/img/logo109.6a71aae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo109.png
// module id = 1uaj
// module chunks = 1